import $ from "jquery";

import "../styles/main.scss";
import "plyr/dist/plyr.css";
import "./nav-mobile";

import { registerPlayer } from "./plyr";
import { typograph } from "./typograph";

const ready = function() {
  registerPlayer("#initializePlyr", ".plyr-player");
  typograph();

  const $welcomeForm = $(".welcome-form form");
  // const $fieldsets = $welcomeForm.find("fieldset");

  $welcomeForm.on("submit", async event => {
    event.preventDefault();

    const contacts = event.target.contacts.value;

    if (!contacts) {
      $welcomeForm.addClass("--client-error");
      return;
    }

    $welcomeForm
      .addClass("--sending")
      .removeClass(["--server-error", "--sent"]);
    // $fieldsets.attr("disabled", "true");

    const budget = event.target.budget.value;
    const company = event.target.company.value;
    const name = event.target.name.value;
    const description = event.target.description.value;

    const options = [];

    $welcomeForm.find('[name="options"]:checked').each(function() {
      options.push(this.value);
    });

    const { action, method } = event.target;
    const response = await fetch(action, {
      method,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        budget,
        company,
        name,
        contacts,
        description,
        options
      })
    });

    $welcomeForm.removeClass("--sending");
    // $fieldsets.removeAttr("disabled");

    if (response.ok) $welcomeForm.addClass("--sent");
    else $welcomeForm.addClass("--server-error");
  });

  $welcomeForm.find('[name="contacts"]').on("focus", () => {
    $welcomeForm.toggleClass("--client-error", false);
  });

  const initBoldScroll = el => {
    if (!el) return;

    const wrapWords = node => {
      Array.from(node.childNodes).forEach(child => {
        if (child.nodeType === Node.TEXT_NODE) {
          const frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(part => {
            if (/^\s+$/.test(part) || part === "") {
              frag.appendChild(document.createTextNode(part));
            } else {
              const span = document.createElement("span");
              span.className = "js-word";
              if (
                node.classList &&
                node.classList.contains("highlight-green")
              ) {
                span.classList.add("js-word--green");
              }
              span.style.fontWeight = 300;
              span.textContent = part;
              frag.appendChild(span);
            }
          });
          child.replaceWith(frag);
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          wrapWords(child);
        }
      });
    };

    wrapWords(el);

    const words = el.querySelectorAll(".js-word");

    window.addEventListener(
      "scroll",
      () => {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight;
        const delay = vh * 0.5;
        const progress = Math.max(
          0,
          Math.min(1, (vh - rect.top - delay) / (rect.height * 1.2))
        );
        const activeCount = Math.round(progress * words.length);
        words.forEach((w, i) => {
          const active = i < activeCount;
          w.style.fontWeight = active ? 700 : 300;
          if (w.classList.contains("js-word--green")) {
            w.style.color = active ? "RGB(var(--ids__accent-RGB))" : "";
          }
        });
      },
      { passive: true }
    );
  };

  initBoldScroll(document.querySelector(".participants-note--large"));

  // На мобиле подгоняем размер круглого фото в h2 «Автор курса» под высоту текста
  const authorH2Text = document.querySelector(".author-h2__text");
  const authorH2Photo = document.querySelector(
    ".author-h2 .author-photo-inline"
  );
  if (authorH2Text && authorH2Photo) {
    let scheduled = false;
    const syncSize = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (window.matchMedia("(max-width: 767px)").matches) {
          // временно сбрасываем, чтобы текст пересчитался без влияния фиксированного фото
          authorH2Photo.style.width = "";
          authorH2Photo.style.height = "";
          const h = authorH2Text.getBoundingClientRect().height;
          authorH2Photo.style.width = `${h}px`;
          authorH2Photo.style.height = `${h}px`;
        } else {
          authorH2Photo.style.width = "";
          authorH2Photo.style.height = "";
        }
      });
    };
    syncSize();
    window.addEventListener("resize", syncSize);
    window.addEventListener("orientationchange", syncSize);
    window.addEventListener("load", syncSize);
    if (document.fonts && document.fonts.ready)
      document.fonts.ready.then(syncSize);
  }
};

$(document).ready(ready);

// Скелетон-загрузка фото: пока изображение не докачается полностью,
// у элемента нет src — виден шиммер. Затем src проставляется и браузер
// мгновенно рендерит картинку из кеша (без top-to-bottom).
const loadWithSkeleton = img => {
  const src = img.dataset.src;
  if (!src) return;
  const preload = new Image();
  const onReady = () => {
    img.src = src;
    img.classList.add("is-loaded");
    img.removeAttribute("data-src");
  };
  preload.onload = onReady;
  preload.onerror = onReady;
  preload.src = src;
};

const loadAllSkeletonImages = () => {
  document
    .querySelectorAll(".guide-page img[data-src]")
    .forEach(loadWithSkeleton);
};

loadAllSkeletonImages();
window._reobserveLazyImages = loadAllSkeletonImages;

const cta = document.getElementById("course-strategy-cta");
const stickyBtn = document.querySelector(".course-strategy-page__sticky-btn");

if (cta && stickyBtn) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      stickyBtn.classList.toggle("is-hidden", entry.isIntersecting);
    },
    { threshold: 0 }
  );
  observer.observe(cta);

  stickyBtn.addEventListener("click", e => {
    e.preventDefault();
    const start = window.scrollY;
    const end = cta.getBoundingClientRect().top + window.scrollY;
    const duration = 1200;
    const startTime = performance.now();

    const ease = t =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    const step = now => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * ease(progress));
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  });
}

document
  .querySelectorAll(".course-strategy-page__photos-wrapper")
  .forEach(wrapper => {
    const photos = wrapper.querySelector(".course-strategy-page__photos");
    const prevBtn = wrapper.querySelector(".photos-nav__btn--prev");
    const nextBtn = wrapper.querySelector(".photos-nav__btn--next");
    if (!photos || !prevBtn || !nextBtn) return;

    const realImgs = Array.from(photos.querySelectorAll("img"));
    if (realImgs.length < 2) return;

    const total = realImgs.length;

    // Создаём внутренний трек с тремя копиями фотографий, чтобы можно было
    // плавно листать в обе стороны без видимых стыков.
    realImgs.forEach(img => img.remove());

    const track = document.createElement("div");
    track.className = "course-strategy-page__photos-track";
    photos.insertBefore(track, photos.firstChild);

    for (let copy = 0; copy < 3; copy++) {
      for (const img of realImgs) {
        const node = img.cloneNode(true);
        if (copy !== 1) node.setAttribute("aria-hidden", "true");
        track.appendChild(node);
      }
    }

    // Подключаем клоны к lazy-load наблюдателю
    if (typeof window._reobserveLazyImages === "function") {
      window._reobserveLazyImages();
    }

    let currentIndex = total; // стартуем в середине (первая «настоящая»)

    const getStep = () => {
      const img = track.querySelector("img");
      return img ? img.offsetWidth + 1 : photos.clientWidth;
    };

    const setPosition = (index, animate) => {
      const step = getStep();
      track.style.transition = animate ? "transform 0.4s ease" : "none";
      track.style.transform = `translateX(${-index * step}px)`;
    };

    requestAnimationFrame(() => setPosition(currentIndex, false));

    track.addEventListener("transitionend", () => {
      if (currentIndex < total) {
        currentIndex += total;
        setPosition(currentIndex, false);
      } else if (currentIndex >= total * 2) {
        currentIndex -= total;
        setPosition(currentIndex, false);
      }
    });

    prevBtn.addEventListener("click", () => {
      currentIndex -= 1;
      setPosition(currentIndex, true);
    });

    nextBtn.addEventListener("click", () => {
      currentIndex += 1;
      setPosition(currentIndex, true);
    });

    window.addEventListener("resize", () => setPosition(currentIndex, false));

    // Свайп пальцем по галерее
    let touchStartX = null;
    let touchDx = 0;
    let touchActive = false;

    photos.addEventListener(
      "touchstart",
      e => {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchDx = 0;
        touchActive = true;
        track.style.transition = "none";
      },
      { passive: true }
    );

    photos.addEventListener(
      "touchmove",
      e => {
        if (!touchActive || e.touches.length !== 1) return;
        touchDx = e.touches[0].clientX - touchStartX;
        const step = getStep();
        track.style.transform = `translateX(${-currentIndex * step +
          touchDx}px)`;
      },
      { passive: true }
    );

    const finishTouch = () => {
      if (!touchActive) return;
      touchActive = false;
      const step = getStep();
      const threshold = step / 4;

      if (touchDx < -threshold) {
        currentIndex += 1;
      } else if (touchDx > threshold) {
        currentIndex -= 1;
      }
      setPosition(currentIndex, true);
    };

    photos.addEventListener("touchend", finishTouch);
    photos.addEventListener("touchcancel", finishTouch);
  });

const lerp = (a, b, t) => a + (b - a) * t;

const bgStar = document.querySelector(".h1-bg-star");
const bgGreen = document.querySelector(".h2-bg-green");
const bracketsOpen = document.querySelectorAll(".author-quote__bracket--open");
const bracketsClose = document.querySelectorAll(
  ".author-quote__bracket--close"
);
const authorPhoto = document.querySelector(".author-quote__photo");
const parallaxBg = document.querySelectorAll(
  ".course-schedule, .audience-list li, .review-bubble, .course-cta__btn"
);

const isMobile = window.matchMedia("(max-width: 767px)").matches;

if (!isMobile) {
  let targetX = 0,
    targetY = 0;
  let currentX = 0,
    currentY = 0;

  window.addEventListener("mousemove", e => {
    const cx = window.innerWidth / 2;
    const cy = window.innerHeight / 2;
    targetX = (e.clientX - cx) / cx;
    targetY = (e.clientY - cy) / cy;
  });

  const tick = () => {
    currentX = lerp(currentX, targetX, 0.06);
    currentY = lerp(currentY, targetY, 0.06);

    if (bgStar) {
      bgStar.style.transform = `rotate(${currentX *
        6}deg) translate(${currentX * 14}px, ${currentY * 9}px)`;
    }

    if (bgGreen) {
      bgGreen.style.transform = `translateY(-50%) rotate(${currentX *
        5}deg) translate(${currentX * 12}px, ${currentY * 7}px)`;
    }

    bracketsOpen.forEach(el => {
      el.style.transform = `translate(${currentX * -18}px, ${currentY *
        -12}px)`;
    });

    bracketsClose.forEach(el => {
      el.style.transform = `rotate(180deg) translate(${currentX *
        18}px, ${currentY * 12}px)`;
    });

    if (authorPhoto) {
      authorPhoto.style.transform = `translate(${currentX * 14}px, ${currentY *
        10}px)`;
    }

    parallaxBg.forEach(el => {
      el.style.setProperty("--px", `${currentX * 8}px`);
      el.style.setProperty("--py", `${currentY * 5}px`);
    });

    requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
} else {
  const tick = () => {
    const t = window.scrollY * 0.008;

    if (bgStar) {
      // круговая траектория
      bgStar.style.transform = `rotate(${Math.sin(t) *
        6}deg) translate(${Math.sin(t) * 12}px, ${Math.cos(t) * 12}px)`;
    }

    if (bgGreen) {
      // восьмёрка
      bgGreen.style.transform = `translateY(-50%) rotate(${Math.cos(t * 0.8) *
        4}deg) translate(${Math.sin(t * 0.7 + 1) * 11}px, ${Math.sin(
        t * 1.4 + 0.5
      ) * 11}px)`;
    }

    bracketsOpen.forEach(el => {
      // овал по диагонали
      el.style.transform = `translate(${Math.cos(t * 1.3 + 2) *
        -13}px, ${Math.sin(t * 0.9 + 1.2) * 13}px)`;
    });

    bracketsClose.forEach(el => {
      // овал в другую сторону
      el.style.transform = `rotate(180deg) translate(${Math.sin(t * 0.8 + 3) *
        13}px, ${Math.cos(t * 1.2 + 0.3) * 13}px)`;
    });

    if (authorPhoto) {
      // мягкая плавающая траектория
      authorPhoto.style.transform = `translate(${Math.sin(t * 0.9 + 1.5) *
        10}px, ${Math.cos(t * 0.7 + 0.5) * 10}px)`;
    }

    parallaxBg.forEach((el, i) => {
      // у каждого свой путь
      const fx = 0.6 + i * 0.25;
      const fy = 1.1 - i * 0.15;
      el.style.setProperty("--px", `${Math.sin(t * fx + i * 1.5) * 7}px`);
      el.style.setProperty("--py", `${Math.cos(t * fy + i * 0.8) * 7}px`);
    });

    requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
}
